/**
 * Path for the magic-link email login redirect. Used by:
 * - PublicRoutes.tsx (route registration)
 * - cognitoAuth.ts (magic link requester_url)
 * - AuthRedirect.tsx (custom-scheme app handoff)
 */
export const EMAIL_LOGIN_LINK_PATH = "/v2/email-login-link";
